import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const ReportGenerationTool = () => {
  const [selectedReport, setSelectedReport] = useState('');
  const [dateRange, setDateRange] = useState({
    startDate: '',
    endDate: ''
  });
  const [isGenerating, setIsGenerating] = useState(false);

  const reportTypes = [
    { value: 'form16', label: 'Form 16 - TDS Certificate' },
    { value: 'form16a', label: 'Form 16A - TDS on Non-Salary' },
    { value: 'form24q', label: 'Form 24Q - TDS Return' },
    { value: 'form12bb', label: 'Form 12BB - Employee Declaration' },
    { value: 'pf-challan', label: 'PF Challan Report' },
    { value: 'esi-challan', label: 'ESI Challan Report' },
    { value: 'pt-challan', label: 'Professional Tax Challan' },
    { value: 'lwf-challan', label: 'Labour Welfare Fund Report' }
  ];

  const handleGenerateReport = async () => {
    if (!selectedReport || !dateRange.startDate || !dateRange.endDate) {
      return;
    }

    setIsGenerating(true);
    // Simulate report generation
    setTimeout(() => {
      setIsGenerating(false);
      // Mock download
      console.log(`Generating ${selectedReport} for ${dateRange.startDate} to ${dateRange.endDate}`);
    }, 3000);
  };

  const handleBulkGeneration = () => {
    console.log('Starting bulk report generation...');
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name="FileText" size={20} className="text-primary" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground">Report Generation</h3>
          <p className="text-sm text-muted-foreground">Generate statutory compliance reports</p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-6">
        <Select
          label="Report Type"
          placeholder="Select report type"
          options={reportTypes}
          value={selectedReport}
          onChange={setSelectedReport}
          required
        />

        <Input
          label="Start Date"
          type="date"
          value={dateRange.startDate}
          onChange={(e) => setDateRange(prev => ({ ...prev, startDate: e.target.value }))}
          required
        />

        <Input
          label="End Date"
          type="date"
          value={dateRange.endDate}
          onChange={(e) => setDateRange(prev => ({ ...prev, endDate: e.target.value }))}
          required
        />
      </div>

      <div className="flex flex-col sm:flex-row gap-3">
        <Button
          variant="default"
          onClick={handleGenerateReport}
          loading={isGenerating}
          disabled={!selectedReport || !dateRange.startDate || !dateRange.endDate}
          iconName="Download"
          iconPosition="left"
          className="flex-1"
        >
          {isGenerating ? 'Generating Report...' : 'Generate Report'}
        </Button>

        <Button
          variant="outline"
          onClick={handleBulkGeneration}
          iconName="Package"
          iconPosition="left"
          className="flex-1"
        >
          Bulk Generation
        </Button>
      </div>

      <div className="mt-6 p-4 bg-muted rounded-lg">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={16} className="text-primary mt-0.5" />
          <div className="text-sm">
            <p className="text-foreground font-medium mb-1">Report Generation Guidelines</p>
            <ul className="text-muted-foreground space-y-1">
              <li>• Reports are generated in PDF format with digital signatures</li>
              <li>• Form 16/16A include employee-wise TDS calculations</li>
              <li>• Challan reports include payment due dates and amounts</li>
              <li>• Bulk generation processes all selected reports simultaneously</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportGenerationTool;